import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';
import { ClientConfig } from 'client/configuration';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';

import './next-steps.scss';

function createLink(to, text, icon, dataTrackingId) {
  return (
    <Link className="text-primary-darker mb-1_5 mt-0_25" to={to} data-tracking-id={dataTrackingId}>
      <span className={`${icon} link-icon align-top size-24 d-inline-block me-0_5`} aria-hidden />
      {text} <span className="size-10 icon-arrow-right3" aria-hidden />
    </Link>
  );
}

export function NextSteps({ hasHeading = false }) {
  const { url: forumsUrl } = ClientConfig.get('vanillaForums');

  return (
    <div className="next-steps d-flex flex-column align-items-start">
      {hasHeading && <div className="heading-4 mb-1_5">What would you like to do next?</div>}
      {createLink(URL_PATHS.APPRAISAL_LANDING, 'See your car’s value', 'icon-appraisal', 'wr_see_cars_value')}
      {createLink('/new-cars/', 'Research new cars', 'icon-stack', 'wr_research_new_cars')}
      {createLink(forumsUrl, 'Discuss cars with other drivers', 'icon-bubbles', 'wr_discuss_cars')}
    </div>
  );
}

NextSteps.propTypes = {
  hasHeading: PropTypes.bool,
};
